import { isValidEmail } from '@blackbird/common/data-validator';
import z from 'zod';

export const challengeSchema = z.intersection(
  z
    .object({
      challengeName: z.string(),
      challengeCode: z.string().min(1),
    })
    .required(),
  z.object({
    session: z.string().nullable(),
  }),
);

export const forgotPasswordSchema = z
  .object({
    email: z
      .string()
      // .email(), TODO - Reintroduce when zod fixes support for apostrophe in email address prefix
      .refine((value) => isValidEmail(value)),
  })
  .required();

export const setPasswordSchema = z.intersection(
  challengeSchema,
  z
    .object({
      email: z
        .string()
        // .email(), TODO - Reintroduce when zod fixes support for apostrophe in email address prefix
        .refine((value) => isValidEmail(value)),
      password: z.string(),
      confirmPassword: z.string().min(1),
    })
    .required()
    .refine(({ password, confirmPassword }) => password === confirmPassword, {
      message: 'auth:requireEquality',
      path: ['password'],
    }),
);
